// extracted by mini-css-extract-plugin
export default {"qr_container":"TenantPopupQr_qr_container__avsIt","text":"TenantPopupQr_text__K4iec","qr":"TenantPopupQr_qr__aMjky"};